import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-common-terminate-confirm-dialog',
    templateUrl: './common-terminate-confirm-dialog.component.html',
    styleUrls: ['./common-terminate-confirm-dialog.component.scss'],
    standalone: false
})
export class CommonTerminateConfirmDialogComponent implements OnInit, OnDestroy {

  firstMessage = '';
  secondMessage = '';
  thirdMessage = '';
  confirmInput = '';
  onDestroy$ = new Subject();

  constructor(
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.firstMessage = this.data.firstMessage;
    this.secondMessage = this.data.secondMessage;
    this.thirdMessage = this.data.thirdMessage;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.unsubscribe();
  }

  isDisableTerminate(): boolean {
    return this.confirmInput.toLowerCase() !== 'yes';
  }
}
